import { css } from 'styled-components';
import { padding, pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet, interactiveTransition } from 'modules/v2/foundation/theme';
import { fontSize } from './typography';
export const inputHoverStyles = css `
  background-color: ${themeGet('colors.gray.0')};
  border-color: ${(props) => (props.$invalid ? themeGet('colors.red.300') : themeGet('colors.primary.200'))};
  color: ${themeGet('colors.gray.800')};
  border-width: ${pxToRem(1)};
  border-style: solid;
  box-shadow: 0 0 0 ${pxToRem(3)}
    ${(props) => (props.$invalid ? themeGet('colors.red.200') : themeGet('colors.primary.50'))};
`;
export const inputFocusStyles = css `
  outline: none;
  background-color: ${themeGet('colors.gray.0')};
  border-color: ${(props) => (props.$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.400'))};
  color: ${themeGet('colors.gray.800')};
  box-shadow: 0 0 0 ${pxToRem(3)}
    ${(props) => (props.$invalid ? themeGet('colors.red.200') : themeGet('colors.primary.50'))};
`;
export const inputDisabledStyles = css `
  background-color: ${themeGet('colors.gray.50')};
  border: ${pxToRem(1)} solid ${themeGet('colors.gray.200')};
  color: ${themeGet('colors.gray.300')};
`;
export const inputBaseStyles = css `
  ${fontSize('small')};
  ${padding(2, 0)};
  ${interactiveTransition};
  border-radius: ${pxToRem(6)};
  display: block;
  height: ${pxToRem(40)};
  background-color: ${themeGet('colors.gray.0')};
  border: ${pxToRem(1)} solid ${(props) => (props.$invalid ? themeGet('colors.red.500') : themeGet('colors.gray.200'))};
  color: ${themeGet('colors.gray.700')};
  font-family: inherit;
  appearance: none;
`;
export const inputAppearance = ({ appearance = '' }) => {
    switch (appearance) {
        case 'highlight':
            return css `
        & > input,
        & > textarea {
          background-color: ${themeGet('colors.blue.50')};
          border-color: ${themeGet('colors.blue.300')};
          color: ${themeGet('colors.gray.800')};
        }

        & svg {
          fill: ${themeGet('colors.blue.500')};
        }
      `;
        default:
            return css ``;
    }
};
export const inputStyles = css `
  ${inputBaseStyles};

  &:hover {
    ${inputHoverStyles};
  }

  ${(props) => props.$isFocused && inputFocusStyles};
  &:focus-visible {
    ${inputFocusStyles};
  }

  &:disabled {
    ${inputDisabledStyles};
  }

  ::placeholder {
    color: ${themeGet('colors.gray.700')};
    opacity: 1;
  }

  :-ms-input-placeholder {
    color: ${themeGet('colors.gray.700')};
  }

  ::-ms-input-placeholder {
    color: ${themeGet('colors.gray.700')};
  }
`;
